import { Close } from "@mui/icons-material";
import {
  Button,
  Checkbox,
  Dialog,
  Rating,
  Slide,
  TextField,
} from "@mui/material";
import { useFormik } from "formik";
import React, { forwardRef } from "react";
import { useState } from "react";
import { useMutation } from "react-query";
import { writeReviwFn } from "../../../../Services/Products/WriteReview";
import { writeReviwSchema } from "../../../../Schemas";
import { useDispatch } from "react-redux";
import { setSnackbar } from "../../../../Redux/Actions/SnackBar";
import { useNavigate } from "react-router-dom";

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const CreateReview = ({ productId }) => {
  const [open, setOpen] = useState(false);
  const [image, setImage] = useState(null);
  const [recommend, setRecommend] = useState(false);
  const navigate = useNavigate();
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  const handleLogin = () => {
    dispatch(
      setSnackbar({
        open: true,
        message: "Login Required",
        variant: "success",
      })
    );
    navigate("/login");
  };
  const dispatch = useDispatch();
  const { mutate: writeReviw } = useMutation(writeReviwFn, {
    onSuccess: (response) => {
      dispatch(
        setSnackbar({
          open: true,
          message: response?.data?.msg,
          variant: "success",
        })
      );
    },
  });
  const initialValues = {
    rating: 0,
    subject: "",
    comment: "",
    reccomendation: false,
  };
  const { handleBlur, handleChange, handleSubmit, values, errors, touched } =
    useFormik({
      initialValues: initialValues,
      validationSchema: writeReviwSchema,
      onSubmit: () => {
        const reqBody = new FormData();
        reqBody.append("product_id", Number(productId));
        reqBody.append("rating", values.rating);
        reqBody.append("subject", values.subject);
        reqBody.append("comment", values.comment);
        reqBody.append("reccomendation", recommend);
        reqBody.append("review_img", image);
        writeReviw(reqBody);
      },
    });

  return (
    <>
      <Button
        className="!text-sm !capitalize !px-3 !rounded-sm !shadow !bg-white dark:!bg-zinc-900"
        size="small"
        onClick={() =>
          localStorage.getItem("bhaarattoken")
            ? handleClickOpen()
            : handleLogin()
        }
      >
        Rate Product
      </Button>

      <Dialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        className="!w-full"
      >
        <form
          onSubmit={handleSubmit}
          className="flex flex-col w-full justify-center items-center gap-5 p-5 px-10"
        >
          <span className="flex relative w-full">
            <p className="font-bold text-xl">Rate this product</p>
            <span className="absolute right-0">
              <Close
                onClick={handleClose}
                className="!p-px !text-3xl border-2 rounded"
              />
            </span>
          </span>
          <Rating
            id="rating"
            name="rating"
            value={values.rating}
            onChange={handleChange}
          />
          <Button
            variant="outlined"
            component="label"
            className="!w-full !capitalize"
          >
            <input
              type="file"
              hidden
              accept="image/png, image/gif, image/jpeg"
              onChange={(event) => setImage(event.target.files[0])}
            />
            <span className="!text-ellipsis text-center !whitespace-nowrap !overflow-x-hidden w-48">
              {image?.name || "Upload Image"}
            </span>
          </Button>

          <TextField
            id="subject"
            name="subject"
            label="Subject"
            className="w-full"
            size="small"
            onBlur={handleBlur}
            value={values.subject}
            onChange={handleChange}
            error={errors["subject"] && touched["subject"] ? true : false}
            helperText={touched["subject"] && errors["subject"]}
            FormHelperTextProps={{ className: "!text-red-500" }}
          />

          <span className="flex flex-col w-full">
            <TextField
              id="comment"
              name="comment"
              label="Comment"
              rows={3}
              multiline
              size="small"
              onBlur={handleBlur}
              value={values.comment}
              onChange={handleChange}
              error={errors["comment"] && touched["comment"] ? true : false}
              helperText={touched["comment"] && errors["comment"]}
              FormHelperTextProps={{ className: "!text-red-500" }}
              className="w-full"
            />
            <span className="flex items-center">
              <Checkbox
                value={recommend}
                onChange={(event) => setRecommend(event.target.checked)}
                className="!p-1 !pl-0"
              />
              <p>Recommendation</p>
            </span>
          </span>
          <Button
            type="submit"
            disableElevation
            className="!px-6"
            variant="contained"
          >
            Submit
          </Button>
        </form>
      </Dialog>
    </>
  );
};

export default CreateReview;
